<script lang="ts">
  import { fade, fly } from 'svelte/transition';
  import { newLiveChannel } from '$lib/stores/liveChannelStore';
  import { onMount } from 'svelte';
  import { goto } from '$app/navigation';

  // デバッグモード（常時表示用）
  const DEBUG = false;
  
  let toasts: any[] = [];
  const MAX_TOASTS = 3;
  let toastId = 0;

  // デバッグ用のダミーデータ
  const dummyToasts = DEBUG ? [
      { id: 'debug1', name: 'デバッグチャンネル1', thumbnail: '/path/to/dummy1', live_video_id: 'kd0PPNUdrss' },
      { id: 'debug3', name: '長めの名前のデバッグチャンネル3', thumbnail: '/path/to/dummy3', live_video_id: 'debug3' }
  ] : [];

  onMount(() => {
      const unsubscribe = newLiveChannel.subscribe(value => {
          if (value) addToast(value);
      });
      return unsubscribe;
  });

  function addToast(toast) {
      const isDuplicate = toasts.some(t => t.live_video_id === toast.live_video_id);
      if (isDuplicate) return;

      const newToast = { ...toast, id: toastId++ };
      toasts = [newToast, ...toasts].slice(0, MAX_TOASTS);
      if (!DEBUG) setTimeout(() => removeToast(newToast), 10000);
  }

  function removeToast(toast) {
      toasts = toasts.filter(t => t.id !== toast.id);
  }

  async function goToVideo(live_video_id: string) {
    await goto(`/video/${live_video_id}`);
  }

  function truncateText(text: string, maxLength: number): string {
      if (text.length > maxLength) {
          return text.slice(0, maxLength) + '...';
      }
      return text;
  }

  $: displayToasts = DEBUG ? dummyToasts : toasts;
</script>

{#each displayToasts as toast, index (toast.id)}
  <button
      on:click={() => goToVideo(toast.live_video_id)}
      in:fly={{ y: 50, duration: 300 }}
      out:fade={{ duration: 300 }}
      class="fixed right-4 bg-black/70 hover:bg-black/90 backdrop-blur-md text-white/90 hover:text-white 
             px-4 py-2 rounded-full z-50 flex items-center gap-3 transition-all duration-300 
             shadow-lg hover:shadow-xl hover:-translate-y-0.5 group"
      style="bottom: {2.5 + index * 2.5}rem;"
      aria-label="{toast.name}の配信を視聴する"
      role="alert"
  >
      <div class="w-5 h-5 relative">
          <div class="absolute inset-0 bg-red-500 rounded-full animate-ping opacity-30"></div>
          <img
              src={toast.thumbnail}
              alt=""
              class="w-5 h-5 rounded-full object-cover relative z-10 ring-1 ring-white/20"
              loading="lazy"
          />
      </div>
      <span class="text-xs tracking-tight font-medium">
          {truncateText(toast.name, 9)} が配信開始
      </span>
      <span class="text-xs text-white/60 group-hover:text-white/90 transition-colors duration-300 font-medium">
          視聴する
      </span>
  </button>
{/each}

<style>
  .truncate {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      display: block;
  }

  .fixed-width {
      width: 300px; /* 固定幅を設定 */
  }
</style>